import { Component, ElementRef, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './shared/templates/layout/layout.component';
import { getConfirmationDi } from '@cfg/services/confirmation-di';
import { getNotificationDi } from '@cfg/services/notification-di';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { getTranslationDi } from '@cfg/i18n/translation-di';
import { getDialogDi } from '@cfg/services/dialog-di';

/**
 * Componente inicial de la aplicación, aquí se carga el router-outlet
 */
@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    ToastModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    LayoutComponent
  ],
  providers: [
    getConfirmationDi,
    getNotificationDi,
    getTranslationDi,
    getDialogDi
  ],
  template: `
    <app-layout></app-layout>

    <p-confirmDialog
      styleClass="app-confirmation-dialog"
      [style]="confirmationDialogStyle"
    >
      <ng-template #message let-message>
        <div class="app-confirmation-message">
          <i [class]="message.icon"></i>

          <div class="app-confirmation-message__body">
            <p class="app-confirmation-message__text">
              {{ message.message }}
            </p>

            @if (message.detail) {
              <p class="app-confirmation-message__detail">
                {{ message.detail }}
              </p>
            }
          </div>
        </div>
      </ng-template>
    </p-confirmDialog>

    <p-toast />
  `,
  styles: []
})
export class AppComponent implements OnInit {
  readonly confirmationDialogStyle = {
    width: 'min(30rem, calc(100vw - 2rem))'
  };

  /**
   * Crea una instancia de AppComponent.
   * @param _elementRef Referencia al elemento del componente.
   */
  constructor(private _elementRef: ElementRef) {}

  /**
   * Inicializa el componente y elimina el atributo ng-version del elemento
   */
  ngOnInit(): void {
    (this._elementRef.nativeElement as HTMLElement).removeAttribute(
      'ng-version'
    );
  }
}
